/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-procedure.reducer';

export const TreatmentProcedureDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentProcedureEntity = useAppSelector(state => state.treatmentProcedure.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentProcedureDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentProcedure.detail.title">TreatmentProcedure</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentProcedure.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentProcedureEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentProcedure.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentProcedureEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentProcedure.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentProcedureEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentProcedure.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {treatmentProcedureEntity.lastUpdated ? (
              <TextFormat value={treatmentProcedureEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentProcedure.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {treatmentProcedureEntity.microSec ? (
              <TextFormat value={treatmentProcedureEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentProcedure.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {treatmentProcedureEntity.timestampEntry ? (
              <TextFormat value={treatmentProcedureEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.treatmentProcedure.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{treatmentProcedureEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.treatmentProcedure.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{treatmentProcedureEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.treatmentProcedure.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{treatmentProcedureEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.treatmentProcedure.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{treatmentProcedureEntity.modifiedByID}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentProcedure.treatment">Treatment</Translate>
          </dt>
          <dd>{treatmentProcedureEntity.treatment ? treatmentProcedureEntity.treatment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentProcedure.procedure">Procedure</Translate>
          </dt>
          <dd>{treatmentProcedureEntity.procedure ? treatmentProcedureEntity.procedure.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-procedure" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-procedure/${treatmentProcedureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentProcedureDetail;
